import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clickableLinks',
  standalone: true,
  pure: true,
})
export class ClickableLinksPipe implements PipeTransform {
  public transform(text: string): string {
    if (!text) {
      return '';
    }

    // Improved URL regex that handles common punctuation correctly
    const urlRegex = /(https?:\/\/[^\s<>"']+?)(?=[.,;:!?]?(?:\s|$))/g;
    return text.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer" class="text-blue-500">$1</a>');
  }
}
